// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1E-Wy","header":"ReportDetails_header__yf42Q","title":"ReportDetails_title__3fNKh","left":"ReportDetails_left__101Xn"};